import { shallowReactive } from "vue";
import type { NXGDSNotificationProps } from "@nsftx/seven-nxg-design-system-backoffice";

export type StoredNotification = NXGDSNotificationProps & { id: string };

export const notificationsStore = shallowReactive(new Map<string, StoredNotification>());

export function addNotification(id: string, props: NXGDSNotificationProps): void {
  notificationsStore.set(id, { ...props, id });
}

export function removeNotification(id: string): void {
  notificationsStore.delete(id);
}
